import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@features/auth/auth.store';
import { AppPaths } from '@core/routes/app-paths';
import {
  hasJobsAccess,
  hasTruckingJobsAccess,
  hasWorkSessionsReviewAccess,
} from '@core/utils/role.utils';

/**
 * Restricts Jobs routes to contractor jobs users or trucking jobs users.
 * Contractor create/edit routes remain contractor-only.
 */
export const jobsAccessGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();
  const payload = {
    primaryRole: user?.primaryRole,
    roles: user?.roles,
    companyType: user?.companyType,
  };
  const hasContractorJobsAccess = hasJobsAccess(payload);
  const hasTruckingAccess = hasTruckingJobsAccess(payload);
  const url = state.url.split('?')[0];
  const isContractorOnlyChildRoute =
    url === `/${AppPaths.JOBS}/create` || url.startsWith(`/${AppPaths.JOBS}/edit`);

  if (isContractorOnlyChildRoute && !hasContractorJobsAccess && hasTruckingAccess) {
    return router.createUrlTree([AppPaths.JOBS]);
  }

  if (hasContractorJobsAccess || hasTruckingAccess) {
    return true;
  }

  if (hasWorkSessionsReviewAccess(payload)) {
    return router.createUrlTree([AppPaths.WORK_SESSIONS]);
  }

  return router.createUrlTree([AppPaths.PROFILE]);
};
